import React from "react";
import Footer from "./Footer";

export default function TermsContainer({ children }) {
  return (
    <>
      <div className="container">
        <div className="row">
          <div className="col-12">{children}</div>
        </div>
      </div>
      <Footer />
    </>
  );
}
